import(/* webpackMode: "eager" */ "/Users/jacoblindelof/Projects/pcmi-monorepo/apps/go-high-level/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/jacoblindelof/Projects/pcmi-monorepo/apps/go-high-level/src/components/auth-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/Users/jacoblindelof/Projects/pcmi-monorepo/apps/go-high-level/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/Users/jacoblindelof/Projects/pcmi-monorepo/apps/go-high-level/src/trpc/react.tsx");
